import { BaseTextMergeElement } from "../BaseTextMergeElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { ExpressionConfiguration } from "../../../Expressions/ExpressionConfiguration";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { StateManager } from "../../../Common/StateManager";
import { DataDefinition } from "../../../Common/Data/DataDefinition";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExpressionValueType } from "../../../Expressions/ExpressionValueType";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

let _any: AppGlueAny;

export class FieldElement extends BaseTextMergeElement {
    readonly __type = "field";
    readonly name = "Field";
    readonly styleElement: boolean = false;
    readonly ordinal: number = 2;

    constructor(fieldName?: string, variableName?: string) {
        super();

        this._fieldData = new ExpressionConfiguration();
        this._fieldData.executionResult = new StringDataDefinition();
        if (fieldName) this._fieldName = fieldName;
        if (variableName) this._fieldData.rootExpression.expressionRoot.variableName = variableName;
    }

    private _fieldName: string = "Field";

    get fieldName(): string {
        return this._fieldName;
    }

    set fieldName(value: string) {
        this._fieldName = value;
        StateManager.propertyChanged(this, "fieldName");
    }

    private _fieldData: ExpressionConfiguration;

    get fieldData(): ExpressionConfiguration {
        this._fieldData.inputData = () => {
            if (!this.parent) return new DataDefinition();

            return this.parent.getInputData();
        };
        return this._fieldData;
    }

    set fieldData(value: ExpressionConfiguration) {
        this._fieldData = value;
    }

    getStorageData(): object {
        let d = super.getStorageData();

        Reflect.set(d, "fieldName", this._fieldName);
        Reflect.set(d, "fieldData", this._fieldData.getStorageData());

        return d;
    }

    setStorageData(data: object) {
        super.setStorageData(data);
        this._fieldName = Reflect.get(data, "fieldName");
        this._fieldData.setStorageData(Reflect.get(data, "fieldData"));
    }

    output(data: ExecutionData, config: TextMergeConfiguration, testContext: ITestingContext | undefined): string {
        let val = data.get(TextMergeConfiguration.DEFAULT_VALUE_DATA_NAME);
        if (this.fieldData.rootExpression.expressionRoot.valueType !== ExpressionValueType.UNSET) {
            try {
                val = this.fieldData.run(data, testContext);
            } catch (e: AppGlueAny) {
                if (e.message.indexOf("is missing") !== -1) val = "[Error: " + e.message + "]";
            }
        }

        if (data.get(TextMergeConfiguration.HIGHLIGHT_FIELDS_DATA_NAME)) {
            return "<u><b>" + val + "</b></u>";
        } else {
            return val;
        }
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return (
            config.type === TextMergeType.HTML ||
            config.type === TextMergeType.PlAIN ||
            config.type === TextMergeType.MULTI_LINE
        );
    }
}
